import AdminLayout from '../../../components/AdminLayout'
import { MediaPlayerNetworkForm } from '../../../components/MediaPlayerNetworkForm'
import { withUser } from '../../../components/withUser'

const NetworkSetup: React.FC = () => (
  <AdminLayout>
    <MediaPlayerNetworkForm />
  </AdminLayout>
)

export default withUser(NetworkSetup)
